// extracted by mini-css-extract-plugin
module.exports = {"collapse":"mhtZSgGI","panel-wrapper":"qMgaNleK","last-panel-wrapper":"cR8_mXvN"};